import BodyText from 'LuxKit/Typography/BodyText'
import { formatAmpersandSeparator } from 'LuxKit/intl/separators'
import FormatInlineList from 'components/utils/Formatters/FormatInlineList'
import React, { Fragment } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  offersLocations: Array<Array<string>>
}

function HotelBundleSearchTileOverlineLocations({ offersLocations }: Props) {
  const intl = useIntl()
  const ampersandSeparator = formatAmpersandSeparator(intl)
  return <BodyText variant="small" colour="neutral-two">
    {offersLocations.map((locations, index) => <Fragment key={index}>
      {index !== 0 && ampersandSeparator}
      <FormatInlineList list={locations} type="unit" />
    </Fragment>)}
  </BodyText>
}

export default HotelBundleSearchTileOverlineLocations
